const BADGE_CLASSES: Record<string, string> = {
  I: "bg-sky-100 border border-sky-200",
  F: "bg-amber-100 border border-amber-200",
  T: "bg-green-100 border border-green-200",
  Z: "bg-red-100 border border-red-200",
  L: "bg-white-100 border border-white-200",
  D: "bg-slate-100 border border-slate-200",
  R: "bg-blue-100 border border-blue-200",
  N: "bg-red-100 border border-red-200",
  O: "bg-green-100 border border-green-200",
  A: "bg-green-100 border border-green-200",
};

function FlagBadge({ value }: { value: string | null }) {
  if (!value) return <span className="text-xs text-gray-300">—</span>;
  const cls =
    BADGE_CLASSES[value] ?? "bg-gray-100 text-gray-500 border border-gray-200";
  return (
    <span
      className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold ${cls}`}
    >
      {value}
    </span>
  );
}

export { FlagBadge };
